import type { ReactNode } from 'react';

export type Column<Row> = {
  id: string;
  header: string;
  cell: (row: Row) => ReactNode;
  numeric?: boolean;
  primary?: boolean;
  status?: boolean;
  action?: boolean;
  interactive?: boolean;
  sortKey?: string;
};

export const holdsControls = <Row>(column: Column<Row>): boolean =>
  column.action === true || column.interactive === true;

export type SortDirection = 'asc' | 'desc';

export type TableSort = {
  key: string;
  direction: SortDirection;
  onChange: (key: string, direction: SortDirection) => void;
};

export type Pagination = {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
};

export type RowSelection<Row> = {
  selected: ReadonlySet<string>;
  onChange: (selected: ReadonlySet<string>) => void;
  rowLabel: (row: Row) => string;
  allLabel: string;
};

export type TableLabels = {
  previous: string;
  next: string;
  range: (from: number, to: number, total: number) => string;
};
